import { useCallback, useState } from "react";

import { TextField } from "@mui/material";

import { useInterval } from "hooks";

import type { SxProps, Theme } from "@mui/material";

interface Props {
  onShipmentNameChange: (value: string) => void;
  shipmentName: string;
  sx?: SxProps<Theme>;
}

export function QuoteFilterByShipmentNameTextField(props: Props) {
  const { onShipmentNameChange, shipmentName, sx = {} } = props;

  const [searchValue, setSearchValue] = useState<string>("");
  const [lastValueSearched, setLastValueSearched] = useState<string | null>(
    null,
  );

  const search = useCallback(() => {
    if (searchValue === "" && shipmentName !== "") {
      onShipmentNameChange(searchValue);
    } else if (lastValueSearched !== searchValue) {
      onShipmentNameChange(searchValue);
      setLastValueSearched(searchValue);
    }
  }, [
    searchValue,
    lastValueSearched,
    setLastValueSearched,
    onShipmentNameChange,
    shipmentName,
  ]);

  useInterval(search, 3000);

  return (
    <TextField
      onChange={(e) => setSearchValue(e.target.value)}
      label="Shipment Ref/ID"
      value={searchValue}
      sx={sx}
    />
  );
}
